import React from "react";
import { withRouter } from "react-router";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { makeStyles } from "@material-ui/core/styles";
import RobotError from "../../assets/img/error-robot.png";

const useStyles = makeStyles({
  root: {
    width: "100%",
    maxWidth: 500,
    marginTop: "20px",
  },
});

const Error500 = (props) => {
  const classes = useStyles();
  const preventDefault = (event) => {
    event.preventDefault();
    /* window.location.reload(); */
    props.history.push("/app/portal");
  };

  return (
    <div
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
      }}
    >
      <div className={classes.root}>
        <Typography variant="h6" gutterBottom>
          Ha ocurrido un error
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          <Link href="/app/home" onClick={preventDefault}>
            Haga click aca para ir al Portal
          </Link>
        </Typography>
        <img
          src={RobotError}
          style={{ width: 350, height: 350 }}
          alt="robot-error"
        />
      </div>
    </div>
  );
};

export default withRouter(Error500);
